<section class="report-container pr-6 pt-4">
  @if(isReportTemplateDataLoading){
  <div class="h-screen flex items-center justify-center">
    <app-loader [loadingText]="'Loading...'" />
  </div>
  }@else{
    
  @if(!isCanvas){
  <div class="flex justify-between items-center pl-6 pb-2">
    <div class="flex items-center">
      <ui-icon name="arrow-narrow-left" class="stroke-[#475467] mr-2 stroke-2 cursor-pointer hover:stroke-[#0F49A0]"
        size="size-4" (click)="onClickBack()" />
      <ui-icon name="reports" class="stroke-white p-1.5 rounded-[3px] bg-[#77ABF9] mr-2" size="size-4" />
      <div class="ml-2">
        <p class="font-bold text-xl">{{ reportTemplate.name }}</p>

        <div class="tooltip-container">
          <p class="text-sm text-[#475467] custom-report-description">
            {{ reportTemplate.description }}
          </p>
          <span class="tooltip-text text-sm" (click)="$event.stopPropagation()">{{
            reportTemplate.description
            }}</span>
        </div>
      </div>
    </div>
    <div class="mr-6 border border-[#EAECF0] rounded-lg p-2">
      <app-agent-trigger [title]="'Build a report using Natural Language'" />
    </div>
  </div>
  }

  <div class="w-full border-t border-[#EAECF0] flex tr-custom-height" [ngClass]="{'border-r': !isCanvas}">
    @if(!isCanvas){
    <app-report-dataselector
      #reportDataselector
      [loadingDatascopes]="loadingDatascopes"
      [templateTypesLoading]="templateTypesLoading"
      [isNewState]="isNewState"
      [dateTimeFormat]="dateTimeFormat"
      [filterOperators]="filterOperators"
      [filterOperatorKeys]="filterOperatorKeys"
      [savedColumnIds]="savedColumnIds"
      [initialSqlFunctionMap]="sqlFunctionMap"
      [selectedScope]="selectedScope"
      [isSelectedScope]="isSelectedScope"
      [selectedTableIds]="selectedTableIds"
      [appliedDateTimeFormat]="appliedDateTimeFormat"
      [appliedFilters]="savedReportState?.filters || appliedFilters"
      [isExecutingReport]="reportVisualDataLoading"
      [isRunDisabled]="isRunDisabled"
      (scopeSelectedEvent)="onScopeSelected($event)"
      (applyFiltersEvent)="onApplyFilters($event)"
      (runReportEvent)="onRunReport($event)"
      (cancelReportEvent)="onCancelReport()"
      (sqlFunctionAppliedEvent)="onSqlFunctionApplied($event)"
      (clearSelectionsEvent)="onClearSelections()"
      (columnSelectionChangedEvent)="onColumnSelectionChanged($event)"
      >
    </app-report-dataselector>
    }
    <div class="main-section-custom-width">
      @if(!isCanvas){
        <div class="flex p-4 justify-between px-8">
          <div class="flex items-center" *ngIf="isSelectedScope">
            <div class="flex border border-[#EAECF0] rounded-full">
              <div class="hover:bg-[#77ABF9] rounded-[300px] py-3 px-4 group cursor-pointer" [ngClass]="{
                  'bg-[#77ABF9]': reportVisualType == 'TABLE'
                }" (click)="changeReportVisualType('TABLE')">
                <ui-icon name="report-table" class="stroke-[#344054] group-hover:stroke-white stroke-[1.5px]"
                  size="size-4" [ngClass]="{
                    'stroke-white': reportVisualType == 'TABLE'
                  }" />
              </div>
              <div class="hover:bg-[#77ABF9] rounded-[300px] py-3 px-4 group cursor-pointer" [ngClass]="{
                  'bg-[#77ABF9]': reportVisualType == 'CHART'
                }" (click)="changeReportVisualType('CHART')">
                <ui-icon name="template-bar-chart"
                  class="stroke-[#344054] hover:stroke-[#0F49A0] group-hover:stroke-white stroke-[1.5px]" size="size-4"
                  [ngClass]="{
                    'stroke-white': reportVisualType == 'CHART'
                  }" />
              </div>
            </div>
          </div>
          @if(!isCanvas){
            <div class="flex items-center" *ngIf="generatedSql && !reportVisualDataLoading && !reportVisualDataEmptyState">
              <button 
                class="flex items-center gap-2 py-2 px-4 rounded-lg border border-[#EAECF0] hover:bg-gray-50 text-[#344054]"
                (click)="openShowSqlModal()">
                <ui-icon name="code" class="stroke-[#344054] stroke-[1.5px]" size="size-4"></ui-icon>
                <span class="text-sm font-medium">View SQL</span>
              </button>
            </div>
          }
        </div>
      } 
      <div [ngClass]="{'h-full': isCanvas}">
        @if(reportVisualDataLoading){
        <div class="custom-height-initial-state items-center flex flex-col justify-center">
          <app-loader [loadingText]="'Loading...'" />
        </div>
        }@else{
        @if(reportVisualDataEmptyState){
        <div class="custom-height-initial-state items-center flex flex-col justify-center">
          <ui-icon 
            name="reports"
            size="w-[6rem] h-[7rem]"
            class="stroke-[1.5px] mb-8"
            [ngClass]="{
              'stroke-[#f98880]': reportDataError,
              'stroke-[#8080808C]': !reportDataError
            }"
          />
          
          <p 
            class="text-center max-w-[500px]"
            [ngClass]="{
              'text-[#B42318]': reportDataError,
              'text-[#475467]': !reportDataError
            }"
          >
            {{ reportDataEmptyStateMessage }}
          </p>
        </div>
        }@else{
        <div class="w-full" [ngClass]="{'h-full': isCanvas}">
          <app-report-visual-data
            [reportVisualType]="reportVisualType"
            [reportVisualData]="reportVisualData"
            [savedGridFilterModel]="gridFilterModel"
            [savedGridSortModel]="gridSortModel"
            [savedChartModel]="agGridChartModel"
            [reportVisualDataLoading]="reportVisualDataLoading"
            [reportVisualChartType]="agGridChartType"
            [isCanvas]="isCanvas"
            (chartTypeChanged)="onChartTypeChanged($event)"
            (chartModelChanged)="onChartModelChanged($event)"
            (filterChanged)="onFilterChanged($event)"
            (sortChanged)="onSortChanged($event)"
            />
        </div>
        }
        }
      </div>
    </div>
    <!-- Copilot as flex item (not absolute) so quick actions stay visible to its right -->
    <div
      class="relative bg-white z-[999] border-l border-t-0 border-r-0 border-b-0 border-[#EAECF0] h-full resize-container select-none flex-shrink-0"
      *ngIf="isQuickModalOpen"
      [style.width.px]="modalWidth"
    >

      <div
        class="absolute left-0 top-1/2 -translate-y-1/2 w-2 h-full cursor-col-resize flex items-center justify-center hover:bg-gray-100"
        (mousedown)="initResize($event)"
      >
        <!-- <ui-icon name="resize-horizontal" class="stroke-gray-500" size="size-4"></ui-icon> -->
      </div>
    
      <report-actions
      [selectedAction]="selectedAction"
      [isValidSelection]="isValidSelection"
      [selectedTableIds]="savedReportState?.selectedTableIds || selectedTableIds"
      [savedColumnIds]="savedReportState?.savedColumnIds || savedColumnIds"
      [insights]="savedReportState?.insights?.length ? savedReportState?.insights : insights"
      [loadingInsights]="loadingInsights"
      (generateInsights)="generateInsights()"
      [reportVisualData]="savedReportState?.reportVisualData || reportVisualData"
      (closeQuickActionModal)="closeQuickActionModal()"
      [reportTemplate]="savedReportState?.reportTemplate || reportTemplate"
      (afterSaveReport)="afterSaveReport($event)"
      [agGridChartType]="agGridChartType"
      [selectedScope]="savedReportState?.selectedScope || selectedScope"
      [checkedColumns]="reportDataselector.checkedColumns || checkedColumns"
      [reportVisualType]="reportVisualType"
      [isSavedReport]="isSavedReport"
      [getSQLFunctionForColumn]="getSQLFunctionForColumn.bind(this)"
      [conversations]="conversations"
      (emitConversations)="updateConversations($event)"
      (askQuestion)="handleCopilotQuestion($event)"
      [appliedFilters]="savedReportState?.filters || appliedFilters"
      [reportId]="reportId"
      [selectedDateTimeFormat]="selectedDateTimeFormat"
      [appliedDateTimeFormat]="appliedDateTimeFormat"
      [customDateFormat]="customDateFormat"
      [currentReportState]="currentReportState"
      [reportVisualDataComponent]="reportVisualDataComponent"
      (switchVisualizationType)="changeReportVisualType($event)"
      class="h-full flex flex-col"
    />
    
    </div>

    @if(!isCanvas){
    <div class="border-l border-[#EAECF0] p-3 flex flex-col items-center gap-3 flex-shrink-0" *ngIf="isSelectedScope">
      <div *ngFor="let action of quickActions" (click)="onQuickActionClick(action)"
        class="p-2 bg-[#F2F4F7] rounded-[4px] cursor-pointer hover:bg-[#C3D9FA]">
        <ui-icon [name]="action.name" [ngClass]="getIconClasses(action)" size="size-4"></ui-icon>
      </div>
    </div>
    }
  </div>
  }

  <app-sql-playground-modal
  [show]="showSqlModal"
  [generatedSqlOriginal]="generatedSql"
  [initialGeneratedSql]="generatedSql"
  [formattedSqlHtml]="formattedSqlHtml"
  [isSqlEditable]="false"
  [isRunSqlLoading]="isRunSqlLoading"
  [isSqlErrorResponse]="isSqlErrorResponse"
  [isLatestQuery]="true"
  [approvedSql]="generatedSql"
  (close)="closeShowSqlModal()"
  (edit)="enableSqlEditing()"
  (cancelEdit)="isSqlEditable = false"
  [disableEditing]="true"
  [disableRun]="true"
></app-sql-playground-modal>

</section>